import utils from 'helpers/utils';

const ROLE_ADMIN = 14;
const ROLE_PROVIDER = 15;
const ROLE_RESELLER = 3;
const ROLE_SUPPORT = 4;

let account = null;
let accounts = null;
let resolved = {};
let user = null;

export default {

    /**
     * Checks whether a session is anonymous.
     *
     * @returns bool
     */
    isAnonymous: function () {
        return user === null;
    },

    /**
     * Checks whether a session is authenticated.
     *
     * @returns bool
     */
    isLoggedIn: function () {
        return !this.isAnonymous();
    },

    /**
     * Gets the current user.
     *
     * @returns Object
     */
    getUser: function () {
        return user;
    },

    /**
     * Sets the current user.
     */
    setUser: function (value) {
        user = value;
        resolved = {};
    },

    hasAccount: function () {
        return account !== null;
    },

    /**
     * Gets the current account.
     *
     * @returns Object
     */
    getAccount: function () {
        return account;
    },

    /**
     * Gets the current account id.
     *
     * @returns Object
     */
    getAccountId: function () {
        return account.id;
    },

    /**
     * Sets the current account.
     */
    setAccount: function (value) {
        account = value;
        resolved = {};
    },

    /**
     * Gets the possible accounts.
     *
     * @returns Array
     */
    getAccounts: function () {
        return accounts;
    },

    /**
     * Sets the possible accounts.
     */
    setAccounts: function (values) {
        accounts = values;
    },

    /**
     * Clears the current session.
     */
    clearSession: function () {
        user = null;
        account = null;
        accounts = null;
        resolved = {};
    },

    /**
     * Gets the current user ID.
     *
     * @returns Object
     */
    getUserId: function () {
        return user.id;
    },

    /**
     * Gets the current user's name.
     *
     * @returns Object
     */
    getUserName: function () {
        if (!resolved.userName) {
            const {
                first_name,
                last_name,
            } = user;

            resolved.userName = utils.fullName(first_name, last_name);
        }

        return resolved.userName;
    },

    /**
     * Check if the current user is impersonated.
     *
     * @returns bool
     */
    isImpersonated: function () {
        return false;
    },

    /**
     * Check if the current user is enabled.
     *
     * @returns bool
     */
    isEnabled: function () {
        return user.is_enabled || false;
    },

    /**
     * Gets the current user's name.
     *
     * @returns Object
     */
    getCompanyName: function () {
        return user.companyName;
    },

    /**
     * Gets the current role name.
     *
     * @returns string
     */
    getUserRole: function () {
        let resolvedRole = resolved.role;

        if (!resolvedRole && account) {
            resolved.role = resolvedRole = this.getRoleName(account.role_id);
        }

        return resolvedRole;
    },

    /**
     * Gets the current account role id.
     *
     * @returns number
     */
    getAccountRoleId: function () {
        return account.role_id;
    },

    /**
     * Checks whether the user is an Admin.
     *
     * @returns boolean
     */
    isAdmin: function () {
        // TODO: For now we entitle support visually as admins to prevent missing anything
        if (this.isSupport()) {
            return true;
        }

        return this.getAccountRoleId() === ROLE_ADMIN;
    },

    /**
     * Check if is user is owner.
     *
     * @returns bool
     */
    isOwner: function () {
        return account.is_owner;
    },

    /**
     * Checks whether the user is a Provider.
     *
     * @returns boolean
     */
    isProvider: function () {
        return this.getAccountRoleId() === ROLE_PROVIDER;
    },

    /**
     * Checks whether the user is a Reseller.
     *
     * @returns boolean
     */
    isReseller: function () {
        return this.getAccountRoleId() === ROLE_RESELLER;
    },

    /**
     * Checks whether the user is "support".
     *
     * @returns boolean
     */
    isSupport: function () {
        return this.getAccountRoleId() === ROLE_SUPPORT;
    },

    /**
     * Get the previous role name, based on roleId.
     *
     * @returns string
     */
    getRoleName: function (roleId) {
        if (!roleId) {
            return;
        }

        if (roleId === ROLE_RESELLER) {
            return 'publisher';
        }

        if (roleId === ROLE_PROVIDER) {
            return 'travel-provider';
        }

        return 'travel-admin';
    },

    /**
     * Gets the current user's name.
     *
     * @returns Object
     */
    getUserNameInitials: function () {
        if (!resolved.userInitials) {
            const {
                first_name,
                last_name,
            } = user;

            resolved.userInitials = utils.nameInitials(first_name, last_name);
        }

        return resolved.userInitials;
    },
};



// WEBPACK FOOTER //
// ./src/helpers/auth.js